import { requestCountAPI } from "../api/dashboard";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
export const fetchRequestCount = createAsyncThunk("count/fetchRequestCount", async () => {
  try {
    const response = await requestCountAPI();
    return response?.result || {};
  } catch (error) {
    throw new Error(error.message || "Failed to fetch request count");
  }
});
const countSlice = createSlice({
  name: "requestCount",
  initialState: {
    requestCount: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRequestCount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRequestCount.fulfilled, (state, action) => {
        state.loading = false;
        state.requestCount = action.payload;
      })
      .addCase(fetchRequestCount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});
export const selectRequestCount = (state) => state.requestCount.requestCount;
export default countSlice.reducer;
